module.exports = __webpack_public_path__ + "img/premium.ebbfaca4.svg";